import { filter, isEmpty } from '@sama/micro-dash';
import {
  getShapeForEventTracking,
  ShapeState,
} from '../../cross-team-shared/annotation/shared/state/shape-state';
import { selectionToArray } from '../../cross-team-shared/misc-utils';
import { ObjectWith } from '../../cross-team-shared/types/misc';
import {
  PointType,
  ShapeType,
} from '../../team-apis/otterdam/answers/shape-typings';
import { Selection } from './state/abstract-sensor-content-state-2d';

export function getShapesWithSubpointsForEventTracking<
  P extends PointType,
  S extends ShapeType,
>(shapes: ObjectWith<ShapeState<P, S>>, selection: Selection) {
  return filter(shapes, (shape) => !isEmpty(selection[shape.index])).map(
    (shape) => ({
      ...getShapeForEventTracking(shape),
      subpoints: selectionToArray(selection[shape.index]),
    }),
  );
}
